/**
 * <sticky-basket-component> - barre d'ajout au panier sticky en bas du
 * viewport sur mobile (visibilité gated par media query CSS).
 *
 * Au connect :
 *   1. Retire l'attribut [hidden] posé en Liquid (anti-flash desktop).
 *   2. Observe <footer.page-width> : quand il entre dans le viewport,
 *      pose [data-footer-visible] → CSS le fait glisser hors écran.
 *   3. Observe le vrai bouton submit `.product-form__submit` : quand il
 *      est visible, pose [data-submit-visible] → CSS masque la barre
 *      (la sticky bar devient redondante avec le vrai bouton visible).
 *   4. Écoute `variant:change` (dispatché par <variant-selector>) pour
 *      synchroniser l'état [disabled] du bouton sur la dispo de la variante.
 */
class StickyBasketComponent extends HTMLElement {
  connectedCallback() {
    this.removeAttribute("hidden");
    this.button = this.querySelector("button");
    this.button?.addEventListener("click", this.#onClick);

    const footer = document.querySelector("footer.page-width");
    if (footer) {
      this.footerObserver = new IntersectionObserver(this.#onFooterIntersect, { threshold: 0 });
      this.footerObserver.observe(footer);
    }

    const submit = document.querySelector(".product-form__submit");
    if (submit) {
      this.submitObserver = new IntersectionObserver(this.#onSubmitIntersect, { threshold: 0 });
      this.submitObserver.observe(submit);
    }

    document.addEventListener("variant:change", this.#onVariantChange);
  }

  disconnectedCallback() {
    this.footerObserver?.disconnect();
    this.submitObserver?.disconnect();
    this.button?.removeEventListener("click", this.#onClick);
    document.removeEventListener("variant:change", this.#onVariantChange);
  }

  #onClick = () => {
    const target = document.querySelector(".product-form__submit");
    if (!target) return;
    target.scrollIntoView({ behavior: "smooth", block: "center" });
    target.focus({ preventScroll: true });
  };

  #onFooterIntersect = (entries) => {
    const visible = entries[0]?.isIntersecting ?? false;
    this.toggleAttribute("data-footer-visible", visible);
  };

  #onSubmitIntersect = (entries) => {
    const visible = entries[0]?.isIntersecting ?? false;
    this.toggleAttribute("data-submit-visible", visible);
  };

  #onVariantChange = (event) => {
    if (!this.button) return;
    const variant = event.detail?.variant;
    if (!variant) return;
    this.button.disabled = !variant.available;
  };
}

if (!customElements.get("sticky-basket-component")) {
  customElements.define("sticky-basket-component", StickyBasketComponent);
}
